module.exports = __webpack_public_path__ + "static/smile-face-8-efc4b3fd89f945c98e7b7cf34a54ca15.jpg";